import { Radio } from 'antd'
import { type Recommendation } from 'types/services/Recommedation'

import './styles.scss'
interface RadioRecommendationProps {
  value: number
  currentValue: number
  infos: Recommendation
  setCurrentValue: (state: number) => void
  setCurrentRecommendation: (state: Recommendation) => void
}
function RadioRecommendation({
  value,
  currentValue,
  infos,
  setCurrentValue,
  setCurrentRecommendation,
}: RadioRecommendationProps) {
  const isChecked = currentValue === value ? 'checked' : ''

  return (
    <section
      className="containerRadioRecommendation"
      onClick={() => {
        setCurrentValue(value)
        setCurrentRecommendation(infos)
      }}
    >
      <div className={`containerRadioRecommendation__header ${isChecked}`}>
        <div>
          <strong>Recomendação</strong>
          <span>{infos.recommendationText}</span>
        </div>
        <Radio value={value}></Radio>
      </div>
      <div className="containerRadioRecommendation__body">
        <div>
          <strong>
            Agente: <br />
            {infos?.responsibleAgent ?? `Não informado`}
          </strong>
          <span> Instituição: {infos?.institutionRecommender}</span>
          <span>Telefone: {infos?.phoneRecommender}</span>
          <span>E-mail: {infos?.emailRecommender}</span>
        </div>
        <div>
          <strong>
            {' '}
            Autor: <br />
            {infos?.createdBy}
          </strong>
          <span> Instituição: {infos?.institutionRecommender}</span>
          {infos.updatedAt !== undefined ? (
            <span>
              Editado em:{' '}
              {infos.updatedAt.length > 0 &&
                new Date(infos.updatedAt).toLocaleDateString()}{' '}
            </span>
          ) : (
            <span>
              Criado em:{' '}
              {infos.createdAt != null &&
                new Date(infos.createdAt).toLocaleDateString()}
            </span>
          )}
          {infos.isSent === true && (
            <span>
              Encaminhado em:{' '}
              {infos.sentAt !== undefined &&
                new Date(infos.sentAt).toLocaleDateString()}
            </span>
          )}
        </div>
      </div>
    </section>
  )
}

export default RadioRecommendation
